var _defs, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "open_svg__dr",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".open_svg__dt{fill:url(#open_svg__ds)}.open_svg__du{fill:#272727}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "open_svg__ds",
    x1: 203.14,
    y1: 148.18,
    x2: 360.43,
    y2: 148.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4690ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4f2"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "open_svg__du",
    d: "m69.57,348.5c0,6.62,5.38,12,12,12h228.76c27.63,0,50.1-22.48,50.1-50.12v-96.44c0-6.62-5.38-12-12-12s-12,5.38-12,12v96.44c0,14.4-11.71,26.12-26.1,26.12H93.57V119.62c0-14.4,11.71-26.12,26.1-26.12h95.33c6.62,0,12-5.38,12-12s-5.38-12-12-12h-95.33c-27.63,0-50.1,22.48-50.1,50.12v228.88Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "open_svg__dt",
    d: "m356.91,73.01c-1.16-1.16-2.51-2.05-4.01-2.65-1.34-.54-2.75-.83-4.15-.86h-.04s-88.71,0-88.71,0c-6.62,0-12,5.38-12,12s5.38,12,12,12h59.47l-112.82,112.88c-2.27,2.27-3.51,5.28-3.51,8.49,0,3.21,1.25,6.22,3.52,8.49,2.27,2.26,5.28,3.51,8.48,3.51s6.22-1.25,8.49-3.52l112.81-112.87v59.26c0,6.62,5.38,12,12,12s12-5.38,12-12v-88.25c0-1.6-.31-3.15-.92-4.62-.6-1.45-1.48-2.75-2.6-3.87Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/open.1e69f876cd59b835038a724db4ffded8.svg";
export { ForwardRef as ReactComponent };